import { Axios, AxiosError, AxiosResponse } from 'axios';
import { Store } from 'redux';

import { axiosInterceptorActions } from '../../state/axiosInterceptor/axiosInterceptor.actions';
import { API_CAUSED_PAGE_ERROR } from './errorInterceptor/errorInterceptor.constants';

export const connectInterceptions = (axios: Axios, store: Store) => {
  let fetchingRequests: string[] = [];

  axios.interceptors.request.use(
    (config) => {
      fetchingRequests.push(config.url || '');
      store.dispatch(axiosInterceptorActions.setSomeApiFetching(!!fetchingRequests.length));

      return config;
    },
    (error) => {
      fetchingRequests = fetchingRequests.filter(url => url !== error.config?.url);
      store.dispatch(axiosInterceptorActions.setSomeApiFetching(!!fetchingRequests.length));

      return Promise.reject(error);
    });

  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      fetchingRequests = fetchingRequests.filter(url => url !== response.config?.url);
      store.dispatch(axiosInterceptorActions.setSomeApiFetching(!!fetchingRequests.length));

      return response;
    },
    (error: AxiosError): Promise<AxiosError> => {
      const originalRequestUrl = error.config?.url || '';

      fetchingRequests = fetchingRequests.filter(url => url !== originalRequestUrl);
      store.dispatch(axiosInterceptorActions.setSomeApiFetching(!!fetchingRequests.length));

      store.dispatch(axiosInterceptorActions.setRequestError({
        error: error.message,
        api: originalRequestUrl,
      }));

      if (API_CAUSED_PAGE_ERROR.includes(originalRequestUrl)) {
        store.dispatch(axiosInterceptorActions.setApiCausedPageError(true));
      }

      return Promise.reject(error);
    }
  );
};